"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
const app_service_1 = require("../../commons/app.service");
const _4d_mapper_1 = require("4d-mapper");
const material_1 = require("@angular/material");
const core_2 = require("@ngx-translate/core");
const AppBaseComponent_1 = require("../../commons/AppBaseComponent");
const forms_1 = require("@angular/forms");
const ui_manager_service_1 = require("@src/app/xs/services/ui/ui-manager.service");
const ngx_stripe_1 = require("ngx-stripe");
const billing_dialog_component_1 = require("./billing-dialog.component");
const photogram_estimate_price_dialog_component_1 = require("./photogram-estimate-price/photogram-estimate-price-dialog.component");
// generic helpers
const Constants_1 = require("./../../commons/Constants");
const application_events_service_1 = require("../../xs/services/events/application-events.service");
const file_data_service_1 = require("../../v2/commons/file-data.service");
const acl_service_1 = require("@src/app/commons/acl/acl.service");
const BTClient = require('braintree-web/client');
const BTDropIn = require('braintree-web-drop-in');
const BTHostedFields = require('braintree-web/hosted-fields');
class BillingComponent extends AppBaseComponent_1.AppBaseComponent {
    constructor(fourD, service, router, snackBar, dialog, activeRoute, translate, stripeService, v2FileService, uiManager, permissions, fb, applicationEvents) {
        super(service, router, snackBar, dialog, applicationEvents);
        this.fourD = fourD;
        this.service = service;
        this.router = router;
        this.snackBar = snackBar;
        this.dialog = dialog;
        this.activeRoute = activeRoute;
        this.translate = translate;
        this.stripeService = stripeService;
        this.v2FileService = v2FileService;
        this.uiManager = uiManager;
        this.permissions = permissions;
        this.fb = fb;
        // refactor
        this.currencySign = '$';
        // adjustments of a plan (regardless if we're changing the plan or not)
        this.adjustments = false;
        this.selectedPlan = null;
        this.adjustUsers = false;
        this.adjustStorage = false;
        this.adjustProjects = false;
        this.adjustedUsers = 0;
        this.adjustedProjects = 0;
        this.adjustedStorage = 0;
        this.cc = {};
        this.BILLING_QMAP = [
            { id: 'name' },
            { id: 'company' },
            { id: 'email' },
            { id: 'phone' }
        ];
        this.elementsOptions = {
            locale: 'auto'
        };
        this.stripeInitialized = false;
        // whether to show 'other' option for buying credits
        this.showOther = false;
        this.otherValue = 10;
        this.show = {
            showCredits: true
        };
        this.isJapan = false;
        this.stripeTest = this.fb.group({
            name: ['', [forms_1.Validators.required]]
        });
        /*
           this.sub = this.fourD.aa().subscribe(s =>
               this.apis = this.fourD.apis.filter(ap => ap.account.id == this.fourD.aa.id)
        )
        */
    }
    onReady() {
        this.account = this.fourD.activeTeam;
        this.account.fetchObservable().subscribe();
        console.log("!");
        this.fourD.getQuotas().subscribe(s => {
            this.stats = s;
            console.log("!!", s);
        });
        let team = this.fourD.activeTeam;
        let hostname = team['hostname'] ? team['hostname'] : 'other';
        this.isJapan = hostname.indexOf('link') !== -1 ? true : false;
        let plan = this.fourD.activeTeam.plan.id;
        // remove ppk plan
        this.fourD.plans = this.fourD.plans.filter(a => a.seq >= 0);
        this.plans = this.fourD.plans.filter(a => !a.isTrial);
        if (this.fourD.activeTeam.plan.isTrial) {
            if (this.fourD.activeTeam['trialEndDate'])
                this.isTrialDays = Math.round((this.fourD.activeTeam['trialEndDate'] - new Date().getTime()) / (3600000 * 24));
            this.plans.push(this.fourD.activeTeam.plan);
        }
        else {
            this.isTrialDays = null;
        }
        this.plans.sort((a, b) => {
            return a.cost - b.cost;
        });
        this.plans.forEach(plan => {
            plan['showCredits'] = true;
            if (this.isJapan) {
                if (plan['uid'] == 'std' || plan['uid'] == 'Basi_1' || plan['uid'] == 'Adva_1' || plan['uid'] == 'Prem_1') {
                    plan['showCredits'] = false;
                }
            }
        });
        // hide HangOn / waiting box (if open)
        Constants_1.Constants.hideHangOn();
        this.fourD.V.searchByObject(_4d_mapper_1.Invoice)
            .equals('status', 'paid')
            .sortBy('dateMade', true)
            .queryObservable().subscribe(res => {
            this.invoices = res.items;
        });
        if (!this.selectedPlan) {
            this.selectedPlan = this.fourD.activeTeam.plan;
            this.fourD.activeTeam.accountPlanDetails().subscribe(s => {
                this.planAdjustments = s;
                this.curPlanAdjustments = Object.assign({}, s);
            });
        }
        return this.fourD.V.searchByObject(_4d_mapper_1.BillingSetup)
            .equals('account', this.fourD.activeTeam.id)
            .equals('active', true)
            .queryObservable().subscribe(res => {
            if (res.items.length) {
                this.billingSetup = res.items[0];
            }
        });
    }
    // Switch from one plan to another
    switchPlan(p) {
        this.translate.get('PLAN.PLAN_TRANSITION', {
            fromPlan: this.fourD.activeTeam.plan.name,
            fromPrice: this.curPlanAdjustments.price,
            toPlan: this.selectedPlan.name,
            toPrice: this.planAdjustments.price
        }).subscribe(s => this.openDialog('GENERIC.CONFIRM', s, "GENERIC.OK", "GENERIC.CANCEL").subscribe(s => {
            if (s) {
                this.fourD.activeTeam.updatePlan(this.planAdjustments, this.selectedPlan).subscribe(_ => {
                    this.openDialog('GENERIC.SUCCESS', 'PLAN.PLAN_CHANGED');
                    this.v2FileService.refreshWidgets().subscribe();
                    this.onReady();
                }, e => this.openDialog('GENERIC.ERROR', e.message));
            }
        }));
    }
    showThumblabel(me) {
        me.source.thumbLabel = true;
    }
    hideThumblabel(me) {
        me.source.thumbLabel = false;
    }
    reset() {
        this.adjustments = false;
        this.selectedPlan = this.fourD.activeTeam.plan;
        this.updateSliders(false);
    }
    updateSliders(usePreview) {
        if (usePreview) {
            this.fourD.activeTeam.previewPlan(this.planAdjustments, this.selectedPlan).subscribe(s => {
                this.planAdjustments = s;
                this.updateAdjustments();
            });
        }
        else {
            this.fourD.activeTeam.accountPlanDetails(this.selectedPlan).subscribe(s => {
                this.planAdjustments = s;
                this.updateAdjustments();
            });
        }
    }
    updateAdjustments() {
        this.adjustedUsers = 0;
        if (this.planAdjustments && this.planAdjustments.allAdjustments['users']) {
            this.adjustedUsers = this.planAdjustments.allAdjustments['users'];
        }
        this.adjustedProjects = 0;
        if (this.planAdjustments && this.planAdjustments.allAdjustments['projects']) {
            this.adjustedProjects = this.planAdjustments.allAdjustments['projects'];
        }
        this.adjustedStorage = 0;
        if (this.planAdjustments && this.planAdjustments.allAdjustments['storage']) {
            this.adjustedStorage = this.planAdjustments.allAdjustments['storage'];
        }
    }
    topup(amount) {
        // Adding credit
        this.translate.get('PLAN.ADDING_CREDIT', { amount: amount }).subscribe(s => this.openDialog('GENERIC.CONFIRM', s, 'PLAN.PURCHASE', 'GENERIC.CANCEL').subscribe(s => {
            if (s) {
                this.account.buyCredit(amount).subscribe(s => {
                    this.onReady();
                    this.openDialog('GENERIC.SUCCESS', 'PLAN.CREDIT_ADDED');
                }, e => this.openDialog('GENERIC.ERROR', e.message));
            }
        }));
    }
    setDetails() {
        var ref = this.dialog.open(billing_dialog_component_1.BillingDialogComponent, {
            width: '75%',
            data: {}
        });
        ref.afterClosed().subscribe(success => {
            // if plan was success, then reset the selectedPlan to inject new values
            if (success) {
                this.selectedPlan = null;
            }
            this.onReady();
        });
    }
    openEstimatePriceDialog() {
        var ref = this.dialog.open(photogram_estimate_price_dialog_component_1.PhotogramEstimatePriceDialog, {
            width: '50%',
            data: {}
        });
        ref.afterClosed().subscribe(value => this.estimatedPrice = value);
    }
    cancelSubscription() {
        this.openDialogWithMeta({ deletename: name }, 'GENERIC.DIALOG.DELETE.TITLE', 'PLAN.ASK_CANCEL_SUBSCRIPTION', 'GENERIC.YES', 'GENERIC.NO').subscribe(s => {
            this.billingSetup['payCycle'] = '';
            this.billingSetup['plan'] = this.fourD.plans.filter(a => a.isTrial && a.seq >= 0)[0].id;
            this.billingSetup.saveObservable().subscribe(s => {
                this.fourD.activeTeam.fetchObservable().subscribe(_ => this.onReady());
            });
        });
    }
}
exports.BillingComponent = BillingComponent;
